import { Direction, IncomingState, InteractionType, OutgoingState, } from '@debbie/common/dist/interactions/index.js';
import * as caseFilterStore from '@debbie/cortex/dist/insights/caseFilter.js';
import React from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { Checkbox } from '../..//index.js';
import FilterGroup from '../FilterGroup.js';
import FilterOption from '../FilterOption.js';
let tId;
const InteractionsGroup = (props) => {
    const lang = useSelector((s) => s.lang);
    const { caseFilter } = props;
    return (React.createElement(FilterGroup, { name: lang.caseFilter.interactionsGroup },
        React.createElement(FilterOption, { active: !!(caseFilter.interactionTypes && caseFilter.interactionTypes.length), header: lang.caseFilter.interactionType, onDeactivate: () => caseFilterStore.clearFilter('interactionTypes') },
            React.createElement(Select, { value: (caseFilter.interactionTypes || []).map((interactionType) => ({
                    label: `${lang.interactionTypes[interactionType] || ''} (${interactionType})`,
                    value: interactionType,
                })), isMulti: true, placeholder: lang.caseFilter.selectInteractionType, classNamePrefix: "select", options: Object.values(InteractionType).map((entry) => ({
                    label: lang.interactionTypes[entry] || '',
                    value: entry,
                })), onChange: (val) => {
                    const selected = val ? val.map((v) => v.value) : [];
                    caseFilterStore.updateFilter({
                        interactionTypes: selected,
                    });
                } })),
        React.createElement(FilterOption, { active: !!(caseFilter.interactionStates && caseFilter.interactionStates.length), header: lang.caseFilter.interactionState, subheader: lang.caseFilter.doNotHaveFollowingStatusSub, onDeactivate: () => caseFilterStore.clearFilter('interactionStates') },
            React.createElement(Select, { value: (caseFilter.interactionStates || []).map((interactionState) => ({
                    label: lang.interactions[interactionState],
                    value: interactionState,
                })), isMulti: true, placeholder: lang.caseFilter.selectInteractionState, classNamePrefix: "select", options: []
                    .concat(Object.values(OutgoingState))
                    .concat(Object.values(IncomingState))
                    .map((entry) => ({
                    label: lang.interactions[entry],
                    value: entry,
                })), onChange: (val) => {
                    const selected = val ? val.map((v) => v.value) : [];
                    caseFilterStore.updateFilter({
                        interactionStates: selected,
                    });
                } })),
        React.createElement(FilterOption, { active: !!(caseFilter.interactionDirections &&
                caseFilter.interactionDirections.length), header: lang.caseFilter.interactionDirection, onDeactivate: () => caseFilterStore.clearFilter('interactionDirections') },
            React.createElement(Select, { value: (caseFilter.interactionDirections || []).map((interactionDirection) => ({
                    label: lang.interactions[interactionDirection],
                    value: interactionDirection,
                })), isMulti: true, placeholder: lang.caseFilter.selectInteractionDirection, classNamePrefix: "select", options: Object.values(Direction).map((entry) => ({
                    label: lang.interactions[entry],
                    value: entry,
                })), onChange: (val) => {
                    const selected = val ? val.map((v) => v.value) : [];
                    caseFilterStore.updateFilter({
                        interactionDirections: selected,
                    });
                } })),
        React.createElement(FilterOption, { active: typeof caseFilter.noneOfTheAboveInteractions === 'boolean', header: lang.caseFilter.noneOfTheAbove, onDeactivate: () => caseFilterStore.clearFilter('noneOfTheAboveInteractions') },
            React.createElement(Checkbox, { style: { marginBottom: '0' }, checked: caseFilter.noneOfTheAboveInteractions, onChange: (e) => {
                    if (e.target.checked) {
                        caseFilterStore.updateFilter({
                            noneOfTheAboveInteractions: true,
                        });
                        return;
                    }
                    caseFilterStore.clearFilter('noneOfTheAboveInteractions');
                } }))));
};
export default InteractionsGroup;
//# sourceMappingURL=InteractionsGroup.js.map